import styled from 'styled-components';
export default function AdminLayout({ children }){
  return (
    <AdminWrap>
      {children}
    </AdminWrap>
  )
}

const AdminWrap = styled.div`
  flex:1;
  background:#fff;

  .title {
    position: relative;
    width: 100%;
    display: flex;
    justify-content: space-between;
    align-items: center;
    height: 40px;

    .tit-head {
      display: flex;
      align-items: center;
      gap: 0 10px;

      i {
        display: block;
        width: 4px;
        height: 32px;
        border-radius: 0 2px 2px 0;
        background: #1e1e1e;
      }

      h4 {
        font-weight: 500;
        font-size: 16px;
        color: #000000;
      }
    }
  }

  .util-menu {
    position: relative;
    margin-top: 35px;
    padding: 15px 20px;
    border-top: 1px solid #eeeeee;
    border-bottom: 1px solid #eeeeee;
    display: flex;
    justify-content: flex-end;
    align-items: center;
    gap: 0 15px;
    width: 100%;

    .menu-in {
      display: flex;
      align-items: center;
      gap: 0 20px;

      .item-in {
        display: flex;
        align-items: center;
        gap: 0 10px;

        label {
          display:none;
        }

        input, select {
          width: 160px;
          height: 40px;
          line-height: 40px;
          padding: 0 16px;
          font-weight: 400;
          font-size: 16px;
          color: #777777;
          border: 1px solid rgba(0, 0, 0, 0.12);
          border-radius: 5px;
          outline: none;
        }
        
        .react-datepicker__input-container input, .react-datepicker-ignore-onclickoutside {
          background:url('https://ust-erp.s3.ap-northeast-2.amazonaws.com/renewal/icon/calendar.svg') top 50% right 10px no-repeat;
          background-size:18px 18px;
        }
      }

      button:not(.react-datepicker__navigation) {
        width: 120px;
        height: 40px;
        line-height: 40px;
        border-radius: 5px;
        background: #a4a4a4;
        font-weight: 400;
        font-size: 16px;
        color: #ffffff;

        &:hover {
          background-color: #7e7e7e;
        }
      }
    }
  }

  .content {
    margin-top: 35px;
    position: relative;
    height: 622px;
    overflow-y: auto;
    
    &.none-util {
      height:729px;
    }

    .admin-table {
      position: relative;

      th {
        padding: 15px 0;
        font-weight: 400;
        font-size: 18px;
        color: #777777;
        background: #f8f8f8;
        text-align: center;
        border-bottom: 1px solid #eeeeee;
        vertical-align: middle;
      }

      td {
        padding: 15px 10px;
        font-weight: 400;
        font-size: 16px;
        color: #000000;
        text-align: center;
        vertical-align: middle;
        border-bottom: 1px solid #eeeeee;

        &.right {
          text-align:right;
        }
        
        a {
          display:inline-block;
          padding:0 20px;
          height: 30px;
          line-height: 30px;
          border-radius: 5px;
          background: #a4a4a4;
          font-weight: 400;
          font-size: 16px;
          color: #ffffff;
        }
      }

      thead {
        position: sticky;
        top: 0;
      }

      tr td:first-child {
        border-left: none;
      }

      tr:nth-child(even) {
        background: #fcfcfc;
      }
    }
    
    .sales-cnt {
      position:relative;
      display:flex;
      align-items: center;
      gap:0 10px;
      margin-bottom:25px;
      
      input {
        width: 160px;
        height: 40px;
        line-height: 40px;
        padding: 0 16px;
        font-weight: 400;
        font-size: 16px;
        color: #777777;
        border: 1px solid rgba(0, 0, 0, 0.12);
        border-radius: 5px;
        outline: none;
      }
    }
    
    .node-item {
      position:relative;
      display:flex;
      flex-direction: column;
      gap:5px 0;
      padding:5px;
      
      .node-tit, .node-lev {
        font-size:14px;
        font-weight:600;
        color:#111;
      }
      
      .node-sales {
        font-size:14px;
        font-weight:600;
        color:#004ea1;
      }
    }
    
    .org-top {
      position:relative;
      display:flex;
      gap:0 60px;
      
      .incentive-wrap {
        position:relative;
        flex:.3;
        display:flex;
        flex-wrap:wrap;
        align-content: flex-start;
        gap:10px 10px;
        
        .input-in {
          width:calc(50% - 5px);
          height:30px;
          
          label {
            display:none;
          }
          
          input {
            width: 100%;
            height: 30px;
            line-height: 430px;
            padding: 0 10px;
            font-weight: 400;
            font-size: 13px;
            color: #777777;
            border: 1px solid rgba(0, 0, 0, 0.12);
            border-radius: 5px;
            outline: none;
          }
        }
      }
      
      .chart-wrap {
        flex:1;
      }
    }
    
    .org-bot {
      margin-top:35px;

      .org-table {
        position: relative;
        border:1px solid #111;
        border-collapse: collapse;
        

        th {
          padding: 10px 0;
          font-weight: 400;
          font-size: 16px;
          color: #111;
          background: #d4d4d4;
          border:1px solid #111;
          text-align: center;
          vertical-align: middle;
        }

        td {
          padding: 10px;
          font-weight: 400;
          font-size: 16px;
          color: #000000;
          border:1px solid #111;
          text-align: center;
          vertical-align: middle;

          &.right {
            text-align:right;
          }

          a {
            display:inline-block;
            padding:0 20px;
            height: 30px;
            line-height: 30px;
            border-radius: 5px;
            background: #a4a4a4;
            font-weight: 400;
            font-size: 16px;
            color: #ffffff;
          }
        }

        thead {
          position: sticky;
          top: 0;
        }

        tr td:first-child {
          border-left: none;
        }

        tr:nth-child(even) {
          background: #fcfcfc;
        }
      }
    }
  }
`
